/**
 * Client-side storage of contributor edit tokens.
 * Format: { [section_id]: edit_token }
 * Persisted in localStorage so the same browser can edit posts made from it.
 */
const KEY = "kimmypedia_edit_tokens";

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") || {};
  } catch {
    return {};
  }
}

export function saveEditToken(sectionId, token) {
  if (!sectionId || !token) return;
  const all = readAll();
  all[sectionId] = token;
  localStorage.setItem(KEY, JSON.stringify(all));
}

export function getEditToken(sectionId) {
  return readAll()[sectionId] || null;
}

export function removeEditToken(sectionId) {
  const all = readAll();
  if (sectionId in all) {
    delete all[sectionId];
    localStorage.setItem(KEY, JSON.stringify(all));
  }
}
